import type { SubscriptionLike } from 'rxjs';
import { Subscription } from 'rxjs';

export abstract class Unsubscribable {
  private _subscriptions: Subscription = new Subscription();

  public set _sub(sub: SubscriptionLike | undefined) {
    if (Boolean(sub)) {
      this._subscriptions.add(sub);
    }
  }
}
